import React from 'react';
import LanguageSelector from '../LanguageSelector';
import CurrencySelector from '../CurrencySelector';
import { useTranslation } from '../../context/TranslationContext';

const AvailabilityHeader = ({
  image,
  currentLanguage,
  onLanguageChange,
  currentCurrency,
  onCurrencyChange,
  navigate,
  isLoggedIn,
  userName,
  showUserDropdown,
  setShowUserDropdown,
  setShowSignInModal,
  handleLogout,
  handleMyBooking,
  accommodationGroupDetail,
}) => {
  const { t } = useTranslation();

  return (
  <header
    className="header shadow-lg border-b border-white/10 text-white px-3 py-2.5 flex items-center justify-between"
    style={{ paddingTop: 'max(0.625rem, env(safe-area-inset-top))' }}
  >
    <div className="flex items-center min-w-0 overflow-hidden mr-2">
      {image && (
        <div className="bg-white rounded-lg p-1 shadow-md">
          {/* alt="Logo" so per-hotel CSS (div:has(> img[alt="Logo"])) can restyle
              this box on mobile too — matches the desktop header targeting. */}
          <img src={image} alt="Logo" className="h-7 w-auto max-w-[140px] object-contain" />
        </div>
      )}
    </div>
    <div className="flex items-center gap-1.5 flex-shrink-0">
      {/* Language Selector - show only if ChooseLanguage is 1 */}
      {Number(accommodationGroupDetail?.hotelMapping?.ChooseLanguage ?? accommodationGroupDetail?.accommodationdetailsdb?.[0]?.ChooseLanguage ?? 0) === 1 && (
        <LanguageSelector
          currentLanguage={currentLanguage}
          onLanguageChange={onLanguageChange}
          buttonClassName="flex items-center justify-center"
        />
      )}
      {/* Currency Selector - show only if ChooseCurrency is 1 */}
      {Number(accommodationGroupDetail?.hotelMapping?.ChooseCurrency ?? accommodationGroupDetail?.accommodationdetailsdb?.[0]?.ChooseCurrency ?? 0) === 1 && (
        <CurrencySelector
          currentCurrency={currentCurrency}
          onCurrencyChange={onCurrencyChange}
          buttonClassName="flex items-center space-x-1 px-2 py-1 text-white text-xs font-medium cursor-pointer"
        />
      )}

      {/* Sign In / User Dropdown - Only show when IsLogin = 1 */}
      {Number(accommodationGroupDetail?.hotelMapping?.IsLogin ?? accommodationGroupDetail?.accommodationdetailsdb?.[0]?.IsLogin ?? 1) === 1 && (!isLoggedIn ? (
        <button
          className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-full border border-white/40 text-white text-[11px] font-medium hover:bg-white hover:text-gray-900 hover:border-white transition-all duration-200 uppercase tracking-wider whitespace-nowrap"
          onClick={() => setShowSignInModal(true)}
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          {t('header.signIn')}
        </button>
      ) : (
        <div className="relative user-dropdown-container">
          <button
            className="flex items-center gap-1.5 px-2 py-1.5 text-white hover:bg-white/10 rounded-lg transition-colors"
            onClick={() => setShowUserDropdown(!showUserDropdown)}
          >
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center text-sm font-semibold">
              {userName ? userName.charAt(0).toUpperCase() : 'U'}
            </div>
            <svg
              className={`w-3.5 h-3.5 transition-transform ${showUserDropdown ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {/* Dropdown Menu */}
          {showUserDropdown && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
              <div className="px-4 py-2 border-b border-gray-200">
                <p className="text-sm font-semibold text-gray-900">{userName || t('header.user')}</p>
                <p className="text-xs text-gray-500">{t('header.loggedIn')}</p>
              </div>
              {(accommodationGroupDetail?.IsDashboard == 1 || accommodationGroupDetail?.isDashboard == 1 || accommodationGroupDetail?.accommodationdetailsdb?.[0]?.IsDashboard == 1) && (
              <button
                onClick={handleMyBooking}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                  {t('header.myBooking')}
                </div>
              </button>
              )}
              <button
                onClick={handleLogout}
                className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  {t('header.logout')}
                </div>
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  </header>
  );
};

export default AvailabilityHeader;
